import React, {useEffect, useRef, useState} from "react";
import {useGlobalNotificationMessage} from "../../context/message";
import {useUserGroupService} from "../../services/user-group-service";
import Loading from "../../components/loading";
import HelperService from "../../services/helper-service";
import Select from "react-select";
import {useRoleService} from "../../services/role-service";
import {AppRoles, AppRoleTypes} from "../../utils/constants";
import {userUserGroupRoleRequest} from "../../utils/schemas";

export default function UserGroupsSelect( {userGroupsList=null, groupRolesList=null, selectedUserGroup={}, onChange=null, ...props} ){
  const userGroupService = useUserGroupService();
  const roleService = useRoleService();
  const {addErrorMessage} = useGlobalNotificationMessage();
  const [internalUserGroupsList, setInternalUserGroupsList] = useState([]);
  const [internalGroupRolesList, setInternalGroupRolesList] = useState([]);
  const [internalSelectedUserGroup, setInternalSelectedUserGroup] = useState({});
  const [loaded, setLoaded] = useState(false);

  useEffect(()=>{
    setLoaded(false);
    let loadPromises = [];

    loadPromises.push( new Promise((resolve, reject)=>{
      if (userGroupsList){
        resolve(userGroupsList.map((g)=>{g.label=g.title; g.value=g.id; return g;}));
      } else {
        userGroupService.getList()
          .then((items)=>{
            resolve(items.map((g)=>{g.label=g.title; g.value=g.id; return g;}));
          })
          .catch(error => {
            reject(error);
          })
      }
    }) );

    loadPromises.push( new Promise((resolve, reject)=>{
      if (groupRolesList){
        resolve(groupRolesList.filter((g)=>g.type===AppRoleTypes.group).map((g)=>{g.label=g.title; g.value=g.id; return g;}));
      } else {
        roleService.getList()
          .then((items)=>{
            resolve(items.filter((g)=>g.type===AppRoleTypes.group).map((g)=>{g.label=g.title; g.value=g.id; return g;}));
          })
          .catch(error => {
            reject(error);
          })
      }
    }) );

    Promise.all(loadPromises).then(([userGroupsList, groupRolesList])=>{
      setInternalUserGroupsList(userGroupsList);
      setInternalGroupRolesList(groupRolesList);

      let refreshStateObj = userUserGroupRoleRequest.cast( selectedUserGroup ? selectedUserGroup : {});
      if (!refreshStateObj.role_id && userGroupsList && userGroupsList.length){
        refreshStateObj.role_id = HelperService.getObjByKey(groupRolesList, 'name', AppRoles.groupManager)?.id;
      }
      if (refreshStateObj.role_id){
        refreshStateObj.role = HelperService.getObjByKey(groupRolesList, 'id', refreshStateObj.role_id);
      }
      if (refreshStateObj.user_group_id){
        refreshStateObj.userGroup = HelperService.getObjByKey(userGroupsList, 'id', refreshStateObj.user_group_id);
      }
      setInternalSelectedUserGroup(refreshStateObj);

      setLoaded(true);
    }).catch(error => {
      HelperService.handleApiErrors(error, addErrorMessage, "Nepodarilo sa získať dáta skupín a rolí.");
    })
  }, [selectedUserGroup, userGroupsList, groupRolesList]);

  const selectGroup = (item=null)=>{
    let newObj = userUserGroupRoleRequest.cast({...internalSelectedUserGroup, user_group_id: item ? item.id : null});
    if (onChange && 'function' === typeof onChange){
      setInternalSelectedUserGroup(newObj);
      onChange(newObj);
    }
  };

  const selectGroupRole = (item=null)=>{
    let newObj = userUserGroupRoleRequest.cast({...internalSelectedUserGroup, role_id: item ? item.id : null});
    if (onChange && 'function' === typeof onChange){
      setInternalSelectedUserGroup(newObj);
      onChange(newObj);
    }
  };

  return (
    <>
      {!loaded || !internalSelectedUserGroup && <Loading className="m-2" />}

      {loaded && internalSelectedUserGroup && <>
        <div className={'row'}>
          <div className={'col'}>
            {internalUserGroupsList && internalUserGroupsList.length>0 && <>
              <Select
                options={internalUserGroupsList}
                placeholder={'Vyberte skupinu'}
                isSearchable
                isClearable
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    'borderRadius': '16px',
                  }),
                }}
                value={internalSelectedUserGroup.userGroup}
                onChange={selectGroup}
              />
            </>}
          </div>
          {internalGroupRolesList && internalGroupRolesList.length>0 && internalSelectedUserGroup.user_group_id && <>
            <div className={'col'}>
              <Select
                options={internalGroupRolesList}
                placeholder={'Vyberte skupinovú rolu'}
                isSearchable
                isClearable
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    'borderRadius': '16px',
                  }),
                }}
                value={internalSelectedUserGroup.role}
                onChange={selectGroupRole}
               />
            </div>
          </>}
        </div>
      </>}
    </>
  );
}
